// Module
var code = `<div class="HOA-flex-component">
    <div class="Select Select--ExMonth">
        <select name="expirationDateMonth"
                id="expirationDateMonth"
                tid="expDateMonthSelect"
                [(ngModel)]="localMonthYearData.monthValue"
                [ngClass]="{'HOA-form-select-field-error': !localMonthYearData.isValid}"
                (change)="updateValues()"
                required>
            <option [ngValue]="-1"></option>
            <option *ngFor="let month of monthArray" [ngValue]="month">{{ formatMonth(month) }}</option>
        </select>
        <span class="Select-arrow"></span>
    </div>
    <div class="Select Select--ExYear">
        <select name="expirationDateYear"
                id="expirationDateYear"
                tid="expDateYearSelect"
                [ngClass]="{'HOA-form-select-field-error': !localMonthYearData.isValid}"
                [(ngModel)]="localMonthYearData.yearValue"
                (change)="updateValues()"
                required>
            <option [ngValue]="-1"></option>
            <option *ngFor="let year of yearArray" [ngValue]="year">{{year}}</option>
        </select>
        <span class="Select-arrow"></span>
    </div>
</div>
<div *ngIf="!localMonthYearData.isValid">
    <span class="HOA-form-field-error" tid="expDate-field-error">Please select a valid expiration date.</span>
</div>`;
// Exports
module.exports = code;